<template>
  <c-dialog ref="dialog" height="400" width="600" @resolve="editHandle">
    <c-form ref="form" unit-width="100%">
      <c-input type="hidden" name="id"></c-input>
      <c-form-item label="类目" required tip="请选择关联类目">
        <c-select name="category_id" async @search="searchCategory" v-model="categoryId" :value-data="selectedCategory" :disabled="!changeGroupFlag"></c-select>
      </c-form-item>
      <c-form-item label="分组" required tip="请选择关联分组">
        <c-select name="release_group_id" async @search="searchGroup" v-model="releaseGroupId" :value-data="selectedGroup" :disabled="!categoryId || !changeGroupFlag"></c-select>
      </c-form-item>
      <c-form-item label="质检项名称" required tip="同一分组下，名称不允许重复">
        <c-input name="name" maxlength="100"></c-input>
      </c-form-item>
      <c-form-item label="录入方式" required tip="选择型：从预设质检项值中勾选；输入型：质检时直接填写文本">
        <c-radio-group name="input_type" v-model="inputType" :options="inputTypeOptions"></c-radio-group>
      </c-form-item>
      <c-form-item label="是否必填" required tip="非必填质检项：制作质检报告时不默认选中，且允许取消选中">
        <c-radio-group name="is_required" v-model="isRequired" :options="isRequiredOptions"></c-radio-group>
      </c-form-item>
      <c-form-item v-show="isRequired == 2" label="互斥项" tip="同分组下互斥的另一非必填质检项；质检报告中互斥双方只能选择其一，需选另一方须先取消本项">
        <c-select v-model="mutualParentId" async clearable @search="searchMutual" :value-data="selectedMutual" :disabled="!releaseGroupId"></c-select>
      </c-form-item>
      <c-form-item label="备注">
        <c-input type="textarea" name="remark"></c-input>
      </c-form-item>
    </c-form>
  </c-dialog>
</template>

<script>
import {mapState} from 'vuex'
export default {
  computed: {
  },

  data() {
    return {
      changeGroupFlag:false,//是否允许变更所属分组  true = 允许 （树形表格中不允许变更上级）
      editState: false,
      categoryId:0,
      selectedCategory:[], //已选中的类目
      selectedGroup:[], //已选中的分组
      inputType: 1,       //录入方式 1=选择型 2=输入型
      inputTypeOptions: [
        {name: '选择型', value: '1'},
        {name: '输入型', value: '2'}
      ],
      isRequired: 1,      //是否必填 1=必填 2=非必填（非必填质检项制作报告时不默认选中、可取消选中）
      isRequiredOptions: [
        {name: '必填', value: '1'},
        {name: '非必填', value: '2'}
      ],
      releaseGroupId: 0,   //已选中的分组ID（互斥项下拉按分组过滤）
      mutualParentId: 0,   //互斥质检项ID（同分组下互斥的另一非必填质检项，0=无互斥）
      selectedMutual: [],  //已选中的互斥质检项
      editId: 0            //编辑中的质检项ID（互斥项下拉排除自身）
    }
  },

  methods: {
    /*******搜索类目*****************/
    searchCategory(keyword, resolve){
      this.request({
        url:'/spu/category/options',
        data: {
          keyword: keyword
        },
        success:data => {
            resolve(data);
        }
      })
    },
    /*******搜索分组*****************/
    searchGroup(keyword, resolve){
      this.request({
        url:'/spu/release/parent/options',
        data: {
          category_id:this.categoryId,
          keyword: keyword
        },
        success:data => {
            resolve(data);
        }
      })
    },
    /*******搜索互斥质检项（同分组下非必填质检项，排除自身）*****************/
    searchMutual(keyword, resolve){
      this.request({
        url: '/spu/release/parent/options',
        data: {
          category_id: this.categoryId,
          release_group_id: this.releaseGroupId,
          //仅非必填质检项可选为互斥项
          is_required: 2,
          keyword: keyword
        },
        success: data => {
          //互斥项不能是质检项自身
          if (this.editId) {
            data = (data || []).filter(item => item.value != this.editId);
          }
          resolve(data);
        }
      })
    },
    /*******通过ID查询分组详情*****************/
    getGroupDetail(release_group_id){
      this.request({
        url:'/spu/release/group/detail',
        data: {
            id:release_group_id
        },
        success:data => {
          this.selectedCategory= [{
              name: data.category_name,
              value:data.category_id
          }];
          this.categoryId = data.category_id;
          //已选中的[分组]
          this.selectedGroup = [{
              name: data.group_name,
              value:data.id
          }];
          this.releaseGroupId = data.id;
        }
      })
    },

    /*********打开编辑框，初始化**********/
    open(data,release_group_id) {
      this.editState = !!data;
      this.changeGroupFlag = !release_group_id;
      this.$refs.form.clear();
      this.inputType = 1;
      this.isRequired = 1;
      this.releaseGroupId = 0;
      this.mutualParentId = 0;
      this.selectedMutual = [];
      this.editId = data ? data.id : 0;
      if (data) {
          //已选中的[类目]
          this.selectedCategory = [{
              name: data.category_name,
              value:data.category_id
          }];
          this.categoryId = data.category_id;
          //已选中的[分组]
          this.selectedGroup = [{
              name: data.group_name,
              value:data.release_group_id
          }];
          this.releaseGroupId = data.release_group_id;
          this.inputType = data.input_type || 1;
          this.isRequired = data.is_required || 1;
          //互斥质检项回显（A、B互为互斥，对方行的名称由后端join带出）
          if (data.mutual_parent_id) {
              this.mutualParentId = data.mutual_parent_id;
              this.selectedMutual = [{
                  name: data.mutual_parent_name || ('ID:' + data.mutual_parent_id),
                  value: data.mutual_parent_id
              }];
          }
          this.$refs.form.set(data);
      }else {
          this.getGroupDetail(release_group_id);
      }
      //填充form表单
      this.$refs.dialog.open({
        title: data ? '编辑质检项' : '添加质检项'
      });
    },

    /*******添加、编辑提交处理方法********/
    editHandle (stop, next){
      stop();
      this.$refs.form.submit({
        url: this.editState?'/spu/release/parent/edit':'/spu/release/parent/add',
        rule: {
          category_id: '请选择关联的类目',
          release_group_id: '请选择关联的分组',
          name: '请输入质检项名称'
        },
        dataFormatter: data => {
          //互斥项：仅非必填质检项生效（必填时强制置0），后端同步双向互斥关系
          data.mutual_parent_id = this.isRequired == 2 ? (this.mutualParentId || 0) : 0;
          return data;
        },
        success: (data, res) => {
          next();
          if(this.editState){
            this.$message({
              message: '编辑成功',  // 提示内容,
              type: 'success'
            });
          }else{
            this.$message({
              message: '添加成功',  // 提示内容,
              type: 'success'
            });
          }
          this.$emit('resolve',res);
        }
      });
    }
  }
}
</script>

<style lang="stylus" scoped>
</style>